"use client";

import React from 'react';

// @ts-ignore
import Navbar from "@/components/home/Navbar";
// @ts-ignore
import HeroSection from "@/components/home/HeroSection";
// @ts-ignore
import MainTabs from "@/components/home/MainTabs"; // Import the new MainTabs component
// @ts-ignore
import SessionGuard from "@/components/auth/SessionGuard"; // 导入会话守卫组件

export default function HomePage(): JSX.Element {
  return (
    <SessionGuard>
      <main style={{ overflow: "hidden", position: "relative" }}>
        <Navbar />
        <HeroSection />
        <MainTabs />
      </main>
    </SessionGuard>
  );
}
